// Core modules
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService } from '@services/services.module';
import { SurvaleCommonComponent } from '../../../../common/survale-common.component';

/**
 * AI Policy component
 */
@Component({
    selector: 'app-ai-policy',
    templateUrl: './ai-policy.component.html',
    styleUrls: ['./ai-policy.component.scss'],
    standalone: false
})
export class AiPolicyComponent extends SurvaleCommonComponent implements OnInit, OnChanges {
  @Input() settings: any;

  public aiPolicyForm: UntypedFormGroup;
  public llmOptions = ['Claude', 'Open AI'];

  /**
   * Life cycle method
   */
  constructor(
    private fb: UntypedFormBuilder,
    public authenticationService: AuthenticationService,
  ) {
    super(authenticationService);
  }

  /**
   * Life cycle init method
   */
  ngOnInit(): void {
    this.aiPolicyForm = this.fb.group({
      enableAI: new UntypedFormControl(false),
      llm: new UntypedFormControl('Claude'),
      askQuestionsToData: new UntypedFormControl(false),
      commentClassification: new UntypedFormControl(false),
      sentimentAnalysis: new UntypedFormControl(false),
      analyzeCommentsLegality: new UntypedFormControl(false),
      translateCommentsToEnglish: new UntypedFormControl(false),
    });

    // Subscribe to enableAI changes to handle enabling/disabling of other controls
    this.aiPolicyForm.get('enableAI').valueChanges.subscribe((enabled: boolean) => {
      if (enabled) {
        this.aiPolicyForm.get('llm').enable();
        this.aiPolicyForm.get('askQuestionsToData').enable();
        this.aiPolicyForm.get('commentClassification').enable();
        this.aiPolicyForm.get('sentimentAnalysis').enable();
        this.aiPolicyForm.get('analyzeCommentsLegality').enable();
        this.aiPolicyForm.get('translateCommentsToEnglish').enable();
      } else {
        this.aiPolicyForm.get('llm').disable();
        this.aiPolicyForm.get('askQuestionsToData').disable();
        this.aiPolicyForm.get('commentClassification').disable();
        this.aiPolicyForm.get('sentimentAnalysis').disable();
        this.aiPolicyForm.get('analyzeCommentsLegality').disable();
        this.aiPolicyForm.get('translateCommentsToEnglish').disable();
      }
    });
  }

  /**
   * Set the form value when received from parent
   */
  ngOnChanges(): void {
    if (this.aiPolicyForm && this.settings) {
      const aiSettings = this.settings.aiSettings || {};
      
      // Set default values
      const formValues = {
        enableAI: aiSettings.enableAI || false,
        llm: aiSettings.llm || 'Claude',
        askQuestionsToData: aiSettings.askQuestionsToData || false,
        commentClassification: aiSettings.commentClassification || false,
        sentimentAnalysis: aiSettings.sentimentAnalysis || false,
        analyzeCommentsLegality: aiSettings.analyzeCommentsLegality || false,
        translateCommentsToEnglish: aiSettings.translateCommentsToEnglish || false,
      };

      this.aiPolicyForm.patchValue(formValues);

      // Trigger the enable/disable logic
      if (!formValues.enableAI) {
        this.aiPolicyForm.get('llm').disable();
        this.aiPolicyForm.get('askQuestionsToData').disable();
        this.aiPolicyForm.get('commentClassification').disable();
        this.aiPolicyForm.get('sentimentAnalysis').disable();
        this.aiPolicyForm.get('analyzeCommentsLegality').disable();
        this.aiPolicyForm.get('translateCommentsToEnglish').disable();
      }
    }
  }
}
